import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { Credentials, PasswordResetToken, Username, LoginUuidModel } from 'app/core/authentication/models';
import { Password } from 'app/core/authentication/models/password.model';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LicenseRequestInterface } from '../models/license-request.model';

@Injectable()
export class AuthRestConnectorService extends RestConnectorService {

  constructor(private readonly _httpClient: HttpClient,
              protected readonly _aStore: Store<AppStateInterface>) {
    super(_aStore);
  }

  public licenseCheck(): Observable<number> {
    return this._httpClient.get<any>(
      '/api/auth/licensecheck',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<any>) => {
        return httpResponse.status;
      }),
    );
  }

  public licenseUpdate(licenseData: LicenseRequestInterface): Observable<number> {
    return this._httpClient.post<any>(
      '/api/auth/site-license',
      licenseData,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<any>) => {
        return httpResponse.status;
      }),
    );
  }

  public login(creds: Credentials): Observable<string> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.post<string>(
      '/api/auth',
      creds,
      {
        headers: httpHeaders,
        observe: 'response',
      },
    )
    .pipe(
        map((httpResponse: HttpResponse<string>) => {
          return <string> httpResponse.body;
        }),
    );
  }

  public loginUuid(uuid: LoginUuidModel): Observable<string> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.post<string>(
      '/api/sso/saml/auth',
      uuid,
      {
        headers : new HttpHeaders({ 'Content-Type': 'application/json' }),
        observe: 'response',
      },
    )
    .pipe(
        map((httpResponse: HttpResponse<string>) => {
          return <string> httpResponse.body;
        }),
    );
  }

  public UpdateUuid(uuid: String): Observable<string> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.post<string>(
      '/api/sso/saml/updateIsUsed',
      uuid,
      {
        headers : new HttpHeaders({ 'Content-Type': 'application/json' }),
        observe: 'response',
      },
    )
    .pipe(
        map((httpResponse: HttpResponse<string>) => {
          return <string> httpResponse.body;
        }),
    );
  }

  public logout(): Observable<number> {
    return this._httpClient.get<any>(
      '/api/logout',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<any>) => {
        return httpResponse.status;
      }),
    );
  }

  public passwordReset(username: Username): Observable<number> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.post<string>(
      '/api/auth/sendresetemail',
      username,
      {
        headers: httpHeaders,
        observe: 'response',
      },
    )
    .pipe(
      map((httpResponse: HttpResponse<string>) => {
        return httpResponse.status;
      }),
    );
  }

  public validatePasswordResetToken(resetToken: PasswordResetToken): Observable<string> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.post<string>(
      '/api/auth/validatetoken',
      resetToken,
      {
        headers: httpHeaders,
        observe: 'response',
      },
    )
    .pipe(
        map((httpResponse: HttpResponse<string>) => {
          return <string> httpResponse.body;
        }),
    );
  }

  public updatePassword(password: Password): Observable<number> {
    const httpHeaders: HttpHeaders = this.getHttpHeaders();

    return this._httpClient.put<string>(
      `/api/users/${password.userId}/updatepassword`,
      password,
      {
        headers: httpHeaders,
        observe: 'response',
      },
    )
    .pipe(
      map((httpResponse: HttpResponse<string>) => {
        return httpResponse.status;
      }),
    );
  }
}
